import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BookingRepeat from './partials/repeat';

const Phase = ({ booking, eventHeightMode, startDateFormatted, endDateFormatted, renderMenu }) => {
    const bookingNameClassName = useMemo(() => {
        if (eventHeightMode === 'S') {
            return 'booking-time-name-small';
        }

        if (eventHeightMode === 'M') {
            return 'mediumBookingTitle';
        }

        return 'booking-time-name';
    }, [eventHeightMode]);

    return (
        <>
            {renderMenu ? <i className="fa fa-ellipsis-v booking-option-dots" title="Options" /> : null}
            <span
                className="inner-booking-text"
                title={`${booking.text} - ${startDateFormatted} - ${endDateFormatted}`}
            >
                <BookingRepeat isRepeat={booking.repeatId && booking.repeat && booking.repeatTimes} />
                {eventHeightMode !== 'XS' ? (
                    <div className={bookingNameClassName}>
                        {booking.text}&nbsp;
                        <div
                            className={classNames({
                                'inner-booking-text-large': ['L', 'XL'].includes(eventHeightMode),
                                'd-inline-block': ['S', 'M'].includes(eventHeightMode),
                            })}
                        >
                            {startDateFormatted} - {endDateFormatted}
                        </div>
                    </div>
                ) : null}
            </span>
        </>
    );
};

Phase.propTypes = {
    booking: PropTypes.object,
    eventHeightMode: PropTypes.string,
    startDateFormatted: PropTypes.string,
    endDateFormatted: PropTypes.string,
};

Phase.defaultProps = {
    booking: {},
    eventHeightMode: '',
    startDateFormatted: '',
    endDateFormatted: '',
};

export default Phase;
